import React from "react";
import { Row } from "react-bootstrap";
import { NavLink } from "react-router-dom";

const Main = () => {
	return (
		<div>
			<Row>
				<NavLink to="/signup">Click here to Sign Up</NavLink>
			</Row>
			<Row>
				<NavLink to="/login">Click here to Log In</NavLink>
			</Row>
		</div>
	);
};

export default Main;
